import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useSiteConfig } from "../context/SiteConfigContext";

const FloatingIcon = () => {
      const { config } = useSiteConfig();
 

  return (
    <a
      href={`https://wa.me/+91${config?.whatsappNumber}`}
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    > 
      <FaWhatsapp size={36} />
    </a>
  );
};

export default FloatingIcon;